window.MTGGoldfish = window.MTGGoldfish || {};
window.MTGGoldfish.onDocumentReadyArray = window.MTGGoldfish.onDocumentReadyArray || [];
window.MTGGoldfish.onDocumentReadyArray.push(function() {

  $(document).ready(function() {

      $(document).on('change', '#set-id-completion-selection', function (e) {
        location.href = '/portfolio/set_completion?set_id=' + $(this).val() + '&type=' + getUrlVars()['type']
      });

      var filter_options = { 
        filter_functions : {
          // Add these options to the select dropdown (regex example)
          0 : {
            "\u2713" : function(e, n, f, i) { return /\u2713/.test(e); },
            "\u2717" : function(e, n, f, i) { return /\u2717/.test(e); },
          },
          1 : {
            "\u2713" : function(e, n, f, i) { return /\u2713/.test(e); },
            "\u2717" : function(e, n, f, i) { return /\u2717/.test(e); },
          },
          3 : {
            "Common" : function(e, n, f, i) { return /C/.test(e); },
            "Uncommon" : function(e, n, f, i) { return /U/.test(e); },
            "Rare" : function(e, n, f, i) { return /R/.test(e); },
            "Mythic" : function(e, n, f, i) { return /M/.test(e); },
            "Special" : function(e, n, f, i) { return /S/.test(e); },
          }
        }
      };
      bindTablesorter($(".portfolio-set-tablesorter"), {}, filter_options, "", true);
      bindTablesorterPopover('');
      bindPopover();

      bindTablesorter($(".list-of-sets-tablesorter"), {}, {}, "", true);
      bindTablesorterPopover('');
      bindPopover();
  });

  window.addEventListener("popstate", function(e) {
    var url = document.location.toString();
    if (url.match('#')) {
      $("#toggle-" + url.split('#')[1]).click();
    }
  });
});
var hideColumnSortSpinner = function(column) {
  $('.tablesorter .ajax-indicator').hide();
  $('th .sort-icon').show();
}

window.hideColumnSortSpinner = hideColumnSortSpinner;

function getUrlVars() {
  var vars = [], hash;
  var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
  for (var i = 0; i < hashes.length; i++) {
    hash = hashes[i].split('=');
    vars.push(hash[0]);
    vars[hash[0]] = hash[1];
  }
  return vars;
}
